import React, { useState, useEffect } from "react";
import { Modal, TextInput, Tooltip } from "@carbon/react";
import { Information } from "@carbon/react/icons";
import "./addNewClientByUUID.scss";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function AddNewClientByUUID({ openModal, setOpenModal }) {
  const [guidValue, setGuidValue] = useState("");
  const [validation, setValidation] = useState({
    invalid: false,
    invalidText: "",
  });

  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const trimmedValue = guidValue.trim();
    const isValid =
      /^[A-Za-z0-9]{8}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{12}$/.test(
        trimmedValue
      );

    if (trimmedValue === "") {
      setValidation({ invalid: false, invalidText: "" });
      return;
    }

    if (!isValid) {
      setValidation({
        invalid: true,
        invalidText: `${t("main.chat.addModal.validationText.invalidUUID")}`,
      });
    } else {
      setValidation({ invalid: false, invalidText: "" });
    }
  }, [guidValue, setValidation, t]);

  const handleSearch = () => {
    if (validation.invalid) return;
    if (!guidValue.trim()) {
      setValidation({
        invalid: true,
        invalidText: `${t("main.chat.addModal.validationText.noValue")}`,
      });
      return;
    } else {
      navigate(`/${guidValue}`, { state: { newClient: true } });
    }
  };
  return (
    <Modal
      open={!!openModal}
      onRequestClose={() => setOpenModal(false)}
      modalHeading={`${t("main.chat.addUUIDTitle")}`}
      modalLabel={`${t("main.chat.modalLabel")}`}
      primaryButtonText={`${t("main.chat.addModal.add")}`}
      secondaryButtonText={`${t("main.chat.addModal.cancel")}`}
      onRequestSubmit={handleSearch}
      onSecondarySubmit={() => setOpenModal(false)}
      closeButtonLabel={`${t("main.modalText.close")}`}
    >
      <div className="main_chat_search">
        <TextInput
          id="search-default-1"
          labelText={
                <span className="uuid_label">
                  {t("main.chat.textInputLabel")}
                  <Tooltip
                    label={t("main.chat.uuidDesc")}
                    autoAlign
                  >
                    <Information />
                  </Tooltip>
                </span>
              }
          placeholder={`${t("main.chat.placeholder")}`}
          size="lg"
          value={guidValue}
          onChange={(e) => setGuidValue(e.target.value)}
          required
          invalid={validation.invalid}
          invalidText={validation.invalidText ? validation.invalidText : ""}
        />
      </div>
    </Modal>
  );
}
